/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import ModalTrigger from '../../shared/modal/ModalTrigger';
import { capitalizeFirstChar } from '../../shared/util/assessments';
import { CheckboxRadio } from '../questions/checkboxRadio/CheckboxRadio';
import { NumberSelectQuestion } from '../questions/numberSelectQuestion/NumberSelectQuestion';
import { Radio } from '../questions/radio/Radio';
import { AssessmentPageItem } from '../types/AssessmentPageItem';

export function Alcohol1({
  active,
  assessmentValues,
  questionid,
  questionHeading,
  questionText,
  onOpenModal,
  onSetValue,
}: AssessmentPageItem) {
  const { t } = useTranslation();
  const [periodAlcoholIntake, setPeriodAlcoholIntake] = useState('');
  const [blockOpacity, setBlockOpacity] = useState(0);

  const yesNoOptions = [
    { id: 'yes', title: t('AL001') },
    { id: 'no', title: t('AL002') },
  ];

  const yesNoAlcoholOptions = [
    { id: 'no', title: t('AL003') },
    { id: 'monthly', title: t('AL004') },
    { id: 'weekly', title: t('AL005') },
    { id: 'daily', title: t('AL006') },
  ];

  const beerOptions = [
    { id: 'pint', title: t('AL007') },
    { id: 'half-pint', title: t('AL008') },
  ];

  const beerStrengthOptions = [
    { id: '3', title: '3%' },
    { id: '4', title: '4%' },
    { id: '5', title: '5%' },
    { id: '6', title: '6%' },
    { id: '7', title: '7%' },
  ];

  const wineOptions = [
    { id: '175', title: t('AL009') },
    { id: '250', title: t('AL010') },
  ];

  const wineStrengthOptions = [
    { id: '12', title: '12%' },
    { id: '13', title: '13%' },
    { id: '14', title: '14%' },
    { id: '15', title: '15%' },
  ];

  const spiritOptions = [
    { id: 'single', title: t('AL011') },
    { id: 'double', title: t('AL012') },
  ];

  const spiritStrengthOptions = [
    { id: '20', title: '20%' },
    { id: '37.5', title: '37.5%' },
    { id: '40', title: '40%' },
  ];

  const bingeDrinkOptions = [
    { id: 'never', title: t('AL013') },
    { id: 'less_than_monthly', title: t('AL014') },
    { id: 'monthly', title: t('AL015') },
    { id: 'weekly', title: t('AL016') },
    { id: 'daily', title: t('AL017') },
  ];

  useEffect(() => {
    if (['monthly', 'weekly', 'daily'].includes(assessmentValues.drink_alcohol)) {
      setPeriodAlcoholIntake(
        `${t('assessment.question.alcohol_fade')} ${assessmentValues.drink_alcohol} ${t('AL024')}`
      );
      setTimeout(() => {
        setBlockOpacity(1);
      }, 100);
    } else {
      setPeriodAlcoholIntake('');
    }
  }, [assessmentValues.drink_alcohol]);

  useEffect(() => {
    if (['monthly', 'weekly', 'daily'].includes(assessmentValues.drink_alcohol)) {
      // we check if any alcohol combo selected
      let valid = false;
      let incomplete = false;
      if (
        assessmentValues.beers &&
        assessmentValues.beers > 0 &&
        assessmentValues.beer_type &&
        assessmentValues.beer_strength
      ) {
        valid = true;
      } else if (assessmentValues.beers > 0) {
        incomplete = true;
      }
      if (
        assessmentValues.wines &&
        assessmentValues.wines > 0 &&
        assessmentValues.wine_type &&
        assessmentValues.wine_strength
      ) {
        valid = true;
      } else if (assessmentValues.wines > 0) {
        incomplete = true;
      }
      if (
        assessmentValues.spirits &&
        assessmentValues.spirits > 0 &&
        assessmentValues.spirit_type &&
        assessmentValues.spirit_strength
      ) {
        valid = true;
      } else if (assessmentValues.spirits > 0) {
        incomplete = true;
      }
      // if okay we can progress
      if (valid && !incomplete) {
        document.getElementById('alcohol_fade').classList.remove('req');
      } else {
        document.getElementById('alcohol_fade').classList.add('req');
      }
    }
  }, [assessmentValues]);

  const onSetBeerAmount = (value: { id: string; value: string }) => {
    onSetValue(value);
  };
  const onSetWineAmount = (value: { id: string; value: string }) => {
    onSetValue(value);
  };
  const onSetSpiritAmount = (value: { id: string; value: string }) => {
    onSetValue(value);
  };

  return (
    <div className={`question_container ${active}`} id={questionid}>
      <h1>{questionHeading}</h1>
      <p>{questionText}</p>

      <Radio
        questionid="smoker"
        width="_wide"
        questionTitle={t('assessment.question.smoker')}
        options={yesNoOptions}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
      />
      {assessmentValues.smoker && assessmentValues.smoker === 'yes' && (
        <>
          <NumberSelectQuestion
            questionid="smoke_per_day"
            questionTitle={t('assessment.question.smoke_per_day')}
            minlimit={0}
            maxlimit={100}
            width=""
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            fadeIn="yes"
            controlsInfo={t('A141')}
            labelText={capitalizeFirstChar(t('AL020'))}
          />
          <Radio
            questionid="stop_smoking"
            width=""
            questionTitle={t('assessment.question.stop_smoking')}
            options={yesNoOptions}
            onSetValue={onSetValue}
            assessmentValues={assessmentValues}
            fadeIn="yes"
          />
        </>
      )}
      <Radio
        questionid="drink_alcohol"
        width="_wide"
        questionTitle={t('assessment.question.drink_alcohol')}
        options={yesNoAlcoholOptions}
        onSetValue={onSetValue}
        assessmentValues={assessmentValues}
      />

      {assessmentValues.drink_alcohol &&
        ['monthly', 'weekly', 'daily'].includes(assessmentValues.drink_alcohol) && (
          <div>
            <div id="alcohol_fade" style={{ opacity: blockOpacity }} className="alcohol_info req">
              <fieldset className="question_block third_width" data-input-type="alcohol_beers">
                <legend id="alcohol_beers_legend" className="assessment_question_title srOnly">
                  {periodAlcoholIntake} {t('assessment.question.alcohol.for')} {t('AL026')}
                </legend>
                <ModalTrigger
                  modalText={t('AL025')}
                  onOpenModal={onOpenModal}
                  question="alcohol"
                  questionTitle={periodAlcoholIntake}
                  openModalTriggerText={`${periodAlcoholIntake} ${t('assessment.question.alcohol.for')} ${t('AL026')} ${t('MDL001')}`}
                />
                <NumberSelectQuestion
                  questionid="beers"
                  questionTitle=""
                  labelText={t('assessment.question.alcohol.amount.label')}
                  minlimit={0}
                  maxlimit={100}
                  width=""
                  onSetValue={onSetBeerAmount}
                  assessmentValues={assessmentValues}
                  fadeIn="yes"
                  controlsInfo={`${t('A142')} ${t('AL026')}`}
                  labelId="alcohol_beers_legend"
                />
                <CheckboxRadio
                  questionid="beer_type"
                  width=""
                  options={beerOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_beers_legend"
                  suffix={t('assessment.question.alcohol.unit.label')}
                />
                <CheckboxRadio
                  questionid="beer_strength"
                  width=""
                  options={beerStrengthOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_beers_legend"
                  suffix={t('assessment.question.alcohol.voltage.label')}
                />
              </fieldset>

              <fieldset className="question_block third_width" data-input-type="alcohol_wines">
                <legend id="alcohol_wines_legend" className="assessment_question_title srOnly">
                  {periodAlcoholIntake} {t('assessment.question.alcohol.for')} {t('AL029')}
                </legend>
                <ModalTrigger
                  modalText={t('AL025')}
                  onOpenModal={onOpenModal}
                  question="alcohol"
                  questionTitle={periodAlcoholIntake}
                  openModalTriggerText={`${periodAlcoholIntake} ${t('assessment.question.alcohol.for')} ${t('AL029')} ${t('MDL001')}`}
                />
                <NumberSelectQuestion
                  questionid="wines"
                  questionTitle=""
                  width=""
                  minlimit={0}
                  maxlimit={100}
                  onSetValue={onSetWineAmount}
                  assessmentValues={assessmentValues}
                  controlsInfo={`${t('A142')} ${t('AL029')}`}
                  labelId="alcohol_wines_legend"
                  labelText={t('assessment.question.alcohol.amount.label')}
                />
                <CheckboxRadio
                  questionid="wine_type"
                  width=""
                  options={wineOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_wines_legend"
                  suffix={t('assessment.question.alcohol.unit.label')}
                />
                <CheckboxRadio
                  questionid="wine_strength"
                  width=""
                  options={wineStrengthOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_wines_legend"
                  suffix={t('assessment.question.alcohol.voltage.label')}
                />
              </fieldset>

              <fieldset className="question_block third_width" data-input-type="alcohol_spirits">
                <legend id="alcohol_spirits_legend" className="assessment_question_title srOnly">
                  {periodAlcoholIntake} {t('assessment.question.alcohol.for')} {t('AL030')}
                </legend>
                <ModalTrigger
                  modalText={t('AL025')}
                  onOpenModal={onOpenModal}
                  question="alcohol"
                  questionTitle={periodAlcoholIntake}
                  openModalTriggerText={`${periodAlcoholIntake} ${t('assessment.question.alcohol.for')} ${t('AL030')} ${t('MDL001')}`}
                />
                <NumberSelectQuestion
                  questionid="spirits"
                  questionTitle=""
                  width=""
                  minlimit={0}
                  maxlimit={100}
                  onSetValue={onSetSpiritAmount}
                  assessmentValues={assessmentValues}
                  controlsInfo={`${t('A142')} ${t('AL030')}`}
                  labelId="alcohol_spirits_legend"
                  labelText={t('assessment.question.alcohol.amount.label')}
                />
                <CheckboxRadio
                  questionid="spirit_type"
                  width=""
                  options={spiritOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_spirits_legend"
                  suffix={t('assessment.question.alcohol.unit.label')}
                />
                <CheckboxRadio
                  questionid="spirit_strength"
                  width=""
                  options={spiritStrengthOptions}
                  questionTitle=""
                  onSetValue={onSetValue}
                  assessmentValues={assessmentValues}
                  skippable
                  labelId="alcohol_spirits_legend"
                  suffix={t('assessment.question.alcohol.voltage.label')}
                />
              </fieldset>
            </div>
            <Radio
              questionid="binge_drink"
              width="_wide"
              questionTitle={t('assessment.question.binge_drink')}
              options={bingeDrinkOptions}
              onSetValue={onSetValue}
              assessmentValues={assessmentValues}
            />
          </div>
        )}
    </div>
  );
}
